import React, { useState } from 'react'
import styled from 'styled-components'
import { func, string } from 'prop-types'
import '@fontsource/dm-sans/900.css' // Defaults to weight 400

import {
  LIGHT_GREY,
  METAL,
  RED,
  SILVER,
  TEXT_MEDIUM,
  TEXT_SMALL,
  WHITE,
} from '../../../constants'

import Text from '../Text'

const Container = styled.div`
  position: relative;
  min-height: 35px;
  max-height: 70px;
  background-color: ${WHITE};
  border: 1px solid ${({ isError }) => (isError ? RED : LIGHT_GREY)};
  border-radius: 5px;
  &:focus-within {
    outline-color: ${SILVER};
    outline-offset: 0px;
    outline-style: auto;
    outline-width: 2px;
  }
  padding: 10px 10px 12px 10px;
`

const StyledInput = styled.input`
  width: 100%;
  display: inline-block;
  font-family: 'DM Sans';
  color: ${METAL};
  font-size: ${TEXT_MEDIUM};
  margin: 0;
  background-color: ${WHITE};
  border: 1px solid ${LIGHT_GREY};
  transition: all 0.3s;
  border: none;
  outline: none;
  cursor: pointer;
`

const DateInput = ({
  handleChange,
  value,
  label,
  name,
  setWidth,
  type,
  ...props
}) => {
  return (
    <Container setWidth={setWidth}>
      <label>
        {label && (
          <Text color={SILVER} size={TEXT_SMALL}>
            {label}
          </Text>
        )}
        <StyledInput
          onChange={handleChange}
          value={value}
          name={name}
          type={type}
          {...props}
        />
      </label>
    </Container>
  )
}

DateInput.propTypes = {
  label: string,
  name: string.isRequired,
  handleChange: func,
  value: string,
}
DateInput.displayName = 'DateInput'

export default DateInput
